import Grid from "@mui/material/Grid";
import React from "react";

const DashboardContent = ({ children, isFullWidth, maxWidth }) => {
  return (
    <div className={"dashboard-content"}>
      <div
        className={`${isFullWidth ? "container full-width" : "container"}`}
        style={maxWidth ? { maxWidth } : undefined}
      >
        <Grid container spacing={3}>
          {children}
        </Grid>
      </div>
    </div>
  );
};

export default DashboardContent;
